import React, { useContext } from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NavBarContext from '../../navBarContext';
import MostPopular from './MostPopular';
import BlogsContent from './BlogsContent';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('600')]: {
      display: 'flex',
    },
  },
  rightContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '17px 34px',
    [theme.breakpoints.down('xs')]: {
      padding: '12px 20px',
    },
  },
  header: {
    marginBottom: 16,
    marginRight: 20,
  },
  lists: {
    marginTop: 28,
    [theme.breakpoints.up('600')]: {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },
  image: {
    width: '100%',
    height: 139,
    marginBottom: 6,
    objectFit: 'cover',
  },
  listItem: {
    width: 246,
    marginRight: 21,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  headerSelector: {
    display: 'flex',
  },
}));

function Blogs() {
  const classes = useStyles();
  const { popularBlogs, siteCopy, sendMixpanelEvent } = useContext(
    NavBarContext,
  );
  const clickHandler = (name, element) => {
    sendMixpanelEvent('Menu Item - Clicked', {
      type: 'Blogs',
      name,
      element,
    });
  };
  return (
    <div className={classes.root}>
      <div className={classes.rightContent}>
        <div className={classes.headerSelector} data-test-id="menu-blog-header">
          <Typography className={classes.header} color="textPrimary">
            {_get(siteCopy, ['pageCopy', 'submenu-blogs', 'Latest'])}
          </Typography>
        </div>
        <BlogsContent type="Latest" clickHandler={clickHandler} />
      </div>
      <MostPopular data={popularBlogs} clickHandler={clickHandler} />
    </div>
  );
}

export default Blogs;
